export default "__VITE_ASSET__BaBR8Bkx__"